import { fetchGet } from '../../../store/fetch';

let streets: string[] = [];
export async function loadStreets() {
    if (streets.length === 0) {
        const streetsResponse = await fetchGet('/assets/amsterdam/streets.csv');
        streets = streetsResponse.json.split('\n');
    }
}

export function searchStreet(text: string) {
    const result: string[] = [];
    for (const street of streets) {
        if (street.toLowerCase().includes(text.toLowerCase())) {
            result.push(street);
            if (result.length > 20) {
                break;
            }
        }
    }
    return result;
}
